import { render, staticRenderFns } from "./LayoutSidebarRight.vue?vue&type=template&id=1b1a35f6&scoped=true"
import script from "./LayoutSidebarRight.vue?vue&type=script&lang=js"
export * from "./LayoutSidebarRight.vue?vue&type=script&lang=js"
import style0 from "./LayoutSidebarRight.vue?vue&type=style&index=0&id=1b1a35f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1a35f6",
  null
  
)

export default component.exports